module.exports = __webpack_public_path__ + "img/common_empty.7d6de0b2.png";